import * as React from 'react';
import { Dispatch } from 'redux';
import { ClientViewModel, CreateClientViewModel } from 'stageclip-common';

import { BaseApiPostRequest } from '../generic/baseApiPostRequest';
import * as ClientNormalizers from '../normalizers/clientNormalizers';
import * as EntityNormalizers from '../normalizers/entityNormalizers';

import { toFormData, appendAsJSONFile } from 'helpers/requestHelper';

export class AddClientsRequest extends BaseApiPostRequest<
  ClientViewModel,
  EntityNormalizers.NormalizedSingleEntity<ClientNormalizers.NormalizedClients>
> {
  constructor(formData: CreateClientViewModel, component: React.Component, dispatch: Dispatch) {
    super(formData, component, dispatch);
    this.path = `/clients`;
    this.normalizeMethod = ClientNormalizers.normalizeClient;
  }

  protected generateRequest() {
    const request = super.generateRequest();
    const { clipConfiguration, ...requestBody } = this.body;

    request.body = toFormData(requestBody);
    appendAsJSONFile(request.body, 'clipConfiguration', clipConfiguration);

    return request;
  }

  protected generateHeaders() {
    const headers = super.generateHeaders();
    headers.delete('Content-type');

    return headers;
  }
}
